import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageLines = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.84375 4.6875H4.15625C3.77344 4.6875 3.5 4.98828 3.5 5.34375C3.5 5.72656 3.77344 6 4.15625 6H9.84375C10.1992 6 10.5 5.72656 10.5 5.34375C10.5 4.98828 10.1992 4.6875 9.84375 4.6875ZM7.21875 7.3125H4.15625C3.77344 7.3125 3.5 7.61328 3.5 7.96875C3.5 8.35156 3.77344 8.625 4.15625 8.625H7.21875C7.57422 8.625 7.875 8.35156 7.875 7.96875C7.875 7.61328 7.57422 7.3125 7.21875 7.3125ZM12.25 0.75H1.75C0.765625 0.75 0 1.54297 0 2.5V10.4023C0 11.3594 0.765625 12.1523 1.75 12.1523H4.375V14.4492C4.375 14.6953 4.67578 14.8594 4.89453 14.6953L8.3125 12.1523H12.25C13.207 12.1523 14 11.3594 14 10.4023V2.5C14 1.54297 13.207 0.75 12.25 0.75ZM12.6875 10.4023C12.6875 10.6211 12.4688 10.8398 12.25 10.8398H7.875L5.6875 12.4805V10.8398H1.75C1.50391 10.8398 1.3125 10.6211 1.3125 10.4023V2.5C1.3125 2.28125 1.50391 2.0625 1.75 2.0625H12.25C12.4688 2.0625 12.6875 2.28125 12.6875 2.5V10.4023Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgMessageLines);
export { ForwardRef as ReactComponent };
